import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import {
	Button,
	Modal,
	ModalHeader,
	ModalBody,
} from 'reactstrap';

const DeleteGuideDetailModal = ({ guideDetailsList, handlerGuideDetailsList, dataGuideDetail, isOpen, handlerToggleModal }) => {
	function handlerDelete() {
		const guideDetailFounded = guideDetailsList.find(guideDetail => guideDetail.residue._id == dataGuideDetail.residue._id && guideDetail.residue.name == dataGuideDetail.residue.name);
		if(guideDetailFounded){
			toast.success(`Residuo ${guideDetailFounded.residue.name} eliminado exitosamente.`, { autoClose: 3000 });
			const updatedGuideDetailList = guideDetailsList.filter(guideDetail => guideDetail.residue._id != dataGuideDetail.residue._id && guideDetail.residue.name != dataGuideDetail.residue.name);
			handlerGuideDetailsList(updatedGuideDetailList);
        }
        handlerToggleModal(!isOpen);
	}

	return (
		<div>
			<Modal
				isOpen={isOpen}
				toggle={() => handlerToggleModal()}
				size='sm'
				className='border-0'
				modalClassName='modal fade zoomIn'
				backdrop={'static'}
				centered={true}
			>
				<ModalHeader className='modal-title' />
				<ModalBody className='text-center p-3'>
					<lord-icon
						src='https://cdn.lordicon.com/tdrtiskw.json'
						trigger='loop'
						colors='primary:#f06548,secondary:#405189'
						style={{ width: '90px', height: '90px' }}
					></lord-icon>
					<div className='mt-2'>
						<h3 className='mb-3'>
							¡Estás a punto de eliminar un residuo!
						</h3>
						<p className='text-muted mb-4'>
							Si deseas realizar esta acción debes hacer click en
							confirmar.
						</p>
						<p className='small'>
							Detalle de residuo: {dataGuideDetail?.residue?.name ? dataGuideDetail.residue.name : ''}
						</p>
						<div className='hstack gap-2 justify-content-center'>
							<Button className='btn-danger btn-label' onClick={() => handlerToggleModal()}><i className='icon-x label-icon'></i> Cancelar</Button>
							<button className='btn btn-label btn-primary' onClick={() => handlerDelete()}><i className={`${Icons.check2} label-icon`}></i> Confirmar</button>
						</div>
					</div>
				</ModalBody>
			</Modal>
		</div>
	);
};

export default DeleteGuideDetailModal;
